export default __webpack_public_path__ + "static/media/img-partner-mobile-7-new.4de1640b.png";